import React from 'react'
import PropTypes from 'prop-types'
import './assets/style.scss'

class PreLoader extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      bg: props.bg,
      svgProps: {
        width: props.size,
        height: props.size,
        viewBox: '0 0 100 100',
        preserveAspectRatio: 'xMidYMid',
      },
      pathProps: {
        d: 'M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50',
        fill: props.fill,
        stroke: 'none',
        transform: 'rotate(30 50 51)',
      },
      animateProps: {
        attributeName: 'transform',
        type: 'rotate',
        calcMode: 'linear',
        values: '0 50 51;360 50 51',
        keyTimes: '0;1',
        dur: `${props.duration}s`,
        begin: '0s',
        repeatCount: 'indefinite',
      },
    };

  }

  render() {
    const {isVisible, message} = this.props;

    return isVisible && <div className="PreLoader" style={{background: this.state.bg}}>
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" {...this.state.svgProps}>
          <path {...this.state.pathProps}><animateTransform {...this.state.animateProps}/></path>
        </svg>
      </div>
      <div className="PreLoaderMsg">{message || 'Загрузка ...'}</div>
    </div>
  }

}

PreLoader.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  bg: PropTypes.string,
  fill: PropTypes.string,
  size: PropTypes.number,
  duration: PropTypes.number,
};

PreLoader.defaultProps = {
  bg: 'rgba(255,255,255, .4)',
  fill: 'rgb(222, 54, 216)',
  duration: 1.4,
  size: 75,
  isVisible: false,
};

export default PreLoader;
